import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "container-fluid m-0 p-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (banner) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([banner.cssClasses, 'small text-center p-1'])
            }, [
                _createVNode(_component_g_dynamic_html, {
                    template: banner.content
                }, null, 8, ["template"])
            ], 2));
        }), 256))
    ]));
}
